import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import OnboardingStepWrapper from '../OnboardingStepWrapper';
import { useOnboarding } from '../../../context/OnboardingContext';
import { BusinessIdea } from '../onboarding.types';
import BusinessIdeaViewer from '../../BusinessIdeaViewer';

const BusinessIdeaReview: React.FC = () => {
  const { state, setData, goToNextStep } = useOnboarding();
  const [formData, setFormData] = useState<BusinessIdea | null>(null);

  // Load the enhanced business idea from context
  useEffect(() => {
    if (state.data.businessIdea) {
      setFormData(state.data.businessIdea as BusinessIdea);
    }
  }, [state.data.businessIdea]);

  const handleSave = (updatedBusinessIdea: BusinessIdea) => {
    // Update the context with the final business idea
    setData({ businessIdea: updatedBusinessIdea });
    // The BusinessIdeaViewer will handle saving to Firestore
    // and redirecting to home page
  };

  if (!formData) {
    return (
      <OnboardingStepWrapper
        title="Loading your business idea"
        subtitle="Please wait while we load your enhanced business idea"
        showBackButton={true}
      >
        <div className="text-center">
          <p className="text-gray-300">Loading...</p>
        </div>
      </OnboardingStepWrapper>
    );
  }

  // Determine if user submitted their own idea (enhancing) vs selected from generated ideas
  // Show back button if user came from business ideas selection (not from enhancing their own idea)
  const shouldShowBackButton = state.data.processingType === 'selected-from-generated';

  return (
    <OnboardingStepWrapper
      title="Business Summary"
      subtitle="Our AI has enhanced your idea. Review and make any changes you'd like before continuing."
      showBackButton={shouldShowBackButton}
      showRocketShip={true}
      showPlanetOrange={true}
    >
      <Box className="max-w-4xl mx-auto">
        <BusinessIdeaViewer
          businessIdea={formData}
          readOnly={false}
          onSave={handleSave}
          showActions={true}
          isOnboarding={true}
        />
      </Box>
    </OnboardingStepWrapper>
  );
};

export default BusinessIdeaReview;
